<template>
	<!-- Sidebar Dropdown component, customized dropdown for use in sidebar -->
	<li class="nav-item">
		<a
			class="nav-link"
			@click="show"
			data-toggle="collapse"
			:class="{ 'justify-center': closeMenu, activeRoute: mainRoute === checkRoute }"
		>
			<div class="item mr-4">
				<div @click="openMenu">
					<!-- <span class="iconify icon" :data-icon="iconUrl"></span> -->
							<img  class="icon" :src="iconUrl">

				</div>
				<p class="title mb-0 mr-1 ml-2 title-menu" v-if="!closeMenu">
					{{ title }}
				</p>
			</div>
			<div :class="{ checkIsCollpase: checkIsCollpase }">
			<img
				:src="this.$PATH.GET_IMAGE_PATH('iconPack/arrow-inactive.svg')"
				alt=""
				:class="{ rotate: isActive }"
				v-if="!closeMenu"
			/>
			</div>
		</a>
		<div class="collapse animation" v-if="!closeMenu" v-bind:class="{ show: isActive }">
			<ul class="nav">
				<slot name="navItems"></slot>
			</ul>
		</div>
	</li>
</template>

<script>
export default {
	// get title for dropdown with title prop and icon name with iconName prop
	props: ['title', 'iconUrl', 'iconActive', 'mainRoute'],
	data: function () {
		return {
			isActive: false,
			closeMenu: null,
			checkIsCollpase: true,
		};
	},
	methods: {
		// toggle isActive variable between true or false
		show() {
			this.isActive = !this.isActive;
		},
		
		openMenu() {
			this.$STORE.commit('appConfig/changeMenuStatus', false);
		},
	},
	created() {
		this.closeMenu = this.$STORE.state.appConfig.closeMenu;
	},
	watch: {
		'$STORE.state.appConfig': {
			handler() {
				this.closeMenu = this.$STORE.state.appConfig.closeMenu;
				if(this.$STORE.state.appConfig.closeMenu === true) {
					this.checkIsCollpase = false
				}else {
					this.checkIsCollpase = true
				}
			},
			deep: true,
			immediate: true
		},
	},
	computed: {
		checkRoute() {
			return this.$route.path.split('/')[1];
		},
	},
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(-4px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.nav-item {
	text-align: right;
	list-style: none;
	margin-right: 0 !important;
}

/* Parent row — matches base nav rows */
.nav-link {
	position: relative;
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 10px 14px;
	margin: 2px 0;
	border-radius: 10px;
	color: #99a7c0;
	cursor: pointer;
	transition: background 0.18s ease, color 0.18s ease;

	&:hover {
		background: rgba(255, 255, 255, 0.05);

		.icon {
			opacity: 0.95;
		}
		.title,
		.title-menu {
			color: #e8eefb;
		}
	}

	.item {
		display: flex;
		align-items: center;
		gap: 12px;
		margin-right: 0 !important;
	}
}

.title,
.title-menu {
	font-size: 14px;
	font-weight: 500;
	color: #99a7c0;
	margin: 0 !important;
	transition: color 0.18s ease;
}

.icon {
	width: 20px;
	max-width: 20px;
	height: 20px;
	object-fit: contain;
	filter: brightness(0) invert(1);
	opacity: 0.6;
	transition: opacity 0.18s ease;
}

/* Chevron */
.nav-link > div img {
	width: 13px;
	opacity: 0.45;
	filter: brightness(0) invert(1);
	transition: transform 0.25s ease, opacity 0.18s ease;
}
.rotate {
	transform: rotate(180deg);
	opacity: 0.8;
}

.justify-center {
	justify-content: center;
}

/* Submenu wrapper */
.collapse.animation {
	animation: fadeIn 0.25s ease;
}
.nav {
	list-style: none;
	padding: 0;
	margin: 0;
}

/* Active parent (a child route is active) */
.activeRoute {
	background: rgba(58, 166, 166, 0.1);

	&::before {
		content: '';
		position: absolute;
		right: 0;
		top: 50%;
		transform: translateY(-50%);
		width: 3px;
		height: 60%;
		border-radius: 3px 0 0 3px;
		background: linear-gradient(180deg, #3aa6a6, #2d8b8b);
		box-shadow: -2px 0 12px rgba(58, 166, 166, 0.5);
	}

	.icon {
		opacity: 1;
		filter: brightness(0) invert(1) drop-shadow(0 0 6px rgba(58, 166, 166, 0.7));
	}
	.title,
	.title-menu {
		color: #eaf6ff;
		font-weight: 700;
	}
	> div img {
		opacity: 0.85;
	}
}
</style>